import script from "./WeView.vue?vue&type=script&setup=true&lang=js"
export * from "./WeView.vue?vue&type=script&setup=true&lang=js"

import "./WeView.vue?vue&type=style&index=0&id=121d0366&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121d0366"]])

export default __exports__